import 'slick-carousel';
import { DiscographyHelper } from "./discography-helper";

document.addEventListener("DOMContentLoaded", () => {
    (() => {
        const instagramContainer = document.getElementsByClassName("Instagram");
        let sliderInitialized = false;

        function init() {
            if (instagramContainer.length > 0) {
                window.addEventListener('resize', onWindowResize);
                const showCarousel = DiscographyHelper.useCarousel(768);
                initSlider(showCarousel);
            }
        }

        function onWindowResize() {
            const showCarousel = DiscographyHelper.useCarousel(768);
            initSlider(showCarousel);
        }

        function getWindowWidth() {
            const w = window,
                d = document,
                e = d.documentElement,
                g = d.getElementsByTagName('body')[0],
                x = w.innerWidth || e.clientWidth || g.clientWidth;
            return x;
        }

        function getItemsToShow() {
            if (getWindowWidth() < 768) {
                return 1.75;
            }
            return 3.2;
        }

        function initSlider(showCarousel) {
            if (showCarousel && !sliderInitialized) {
                sliderInitialized = true;
                const sliderSettings = {
                    dots: false,
                    arrows: false,
                    autoplay: false,
                    centerMode: false,
                    draggable: true,
                    infinite: false,
                    speed: 500,
                    slidesToShow: getItemsToShow(),
                    slidesToScroll: 1
                };
                $(".Instagram__grid").slick(sliderSettings);
            } else {
                if (sliderInitialized === true) {
                    $('.Instagram__grid').slick('unslick');
                    sliderInitialized = false;
                }
            }
        }

        init();
    })()
});